import { Box, Stack } from '@chakra-ui/react';
import { useEffect, useState, useRef } from 'react';
import Controls from '../../components/Controls';
import PageWrapper from '../../components/PageWrapper';
import StatsCard from '../../components/StatsCard';
import { useLoadingContext } from '../../context/LoadingContext';
import { useNotifyContext } from '../../context/NotifyContext';
import { useUserContext } from '../../context/UserContext';
import { getDashboardData } from '../../services/DashboardService';
import { patchUser } from '../../services/UserService';

function Dashboard() {
  const notify = useNotifyContext();
  const user = useUserContext();
  const globalLoading = useLoadingContext();
  const [money, setMoney] = useState({ got: 0, dislikes: 0 });
  const [blocks, setBlocks] = useState({ got: [], dislikes: [] });

  async function loadData() {
    try {
      const gigsResponse = await getDashboardData();
      setMoney(gigsResponse.blockMoney);
      setBlocks(gigsResponse.blocks);
    } catch (e) {
      notify.error('Error getting gigs: ', +e.message);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  async function onSwitchClick() {
    globalLoading.start();
    const newValue = !user.userDisabled;

    const newStatus = newValue ? 'Stopping' : 'Starting';

    try {
      await patchUser({
        userId: user.userId,
        body: { userDisabled: Number(newValue), status: newStatus },
      });
      await user.updateUser();

      globalLoading.stop();
    } catch (e) {
      console.log('E: ', e);
      notify.error('Error switching system');
      globalLoading.stop();
    }
  }

  return (
    <Box>
      <Stack spacing={4}>
        <Controls
          status={user.status}
          onSwitchClick={onSwitchClick}
          on={!user.userDisabled}
        />
        <StatsCard money={money.got} blocks={blocks.got} type="Accepted" />
        <StatsCard
          money={money.dislikes}
          blocks={blocks.dislikes}
          type="Rejected"
        />
      </Stack>
    </Box>
  );
}

export default Dashboard;
